import Icon from '@mdi/react';
import { mdilArrowUp } from '@mdi/light-js';

export default function GoToTop(props){
    return (
        <>
            <button
                type="button"
                className={props.showGoTop}
                onClick={props.scrollUp}
                aria-label="Scroll to top"
            >
                <Icon className='icon' path={mdilArrowUp} size={1} color="white"/>
            </button>
        </>
    )
}